'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
   Input,
   useOutsideClick,
   useBreakpointValue,
   useToast,
   ModalFooter,
   Switch,
   FormLabel,
   SimpleGrid,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
   Modal,
   useColorMode,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import JournalVoucherForm from './JournalVoucherForm';
import { columnsJournalVoucherColumn } from 'views/admin/customDataTable/variables/columnsData';
import DynamicTable from 'views/admin/masters/components/DynamicAllDataTable';
import { getJournalVoucher, updateJournalVoucher } from '../../../../redux/actions/journalVoucher';
import { deleteJournalVoucher } from '../../../../redux/actions/journalVoucher';

// filter
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import filter from 'assets/img/nfts/filter.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem } from '@chakra-ui/react';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
//filter end

import { SearchIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import { useUser } from 'contexts';
import DeleteDialog from 'views/admin/masters/components/DeleteDialog';
import { BsEye } from 'react-icons/bs';
import { postColumnsHideShow } from '../../../../redux/actions/utility';
import { X } from 'lucide-react';

const columnHelper = createColumnHelper();
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

export default function JournalVoucher() {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const dispatch = useDispatch();
   const toast = useToast();
   const [sorting, setSorting] = React.useState([]);
   const [data, setData] = React.useState([]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [focusedInput, setFocusedInput] = React.useState(null);
   const [pageSize, setPageSize] = React.useState(10);
   const [currentPage, setCurrentPage] = React.useState(0);
   const [limit, setLimit] = useState(10);
   const [isEditingPage, setIsEditingPage] = useState(false);
   const [pageInputValue, setPageInputValue] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const [searchQuery, setSearchQuery] = React.useState('');
   const JournalVoucher = useSelector((state) => state.journalVoucher?.list || []);
   const pagination = useSelector((state) => state.journalVoucher?.pagination || []);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const isMobileOrTablet = useBreakpointValue({ base: true, md: false, lg: false });
   const { user } = useUser();
   const Admin = user?.isAdmin;
   const companyId = Number(localStorage.getItem('companyId'));
   const JournalVoucherRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.JournalVoucher
      : null;

   const filteredData = React.useMemo(() => {
      if (!searchQuery) return JournalVoucher;
      return JournalVoucher?.filter((row) =>
         columnsJournalVoucherColumn?.some((col) =>
            String(row[col.id]).toLowerCase().includes(searchQuery.toLowerCase()),
         ),
      );
   }, [JournalVoucher, searchQuery, columnsJournalVoucherColumn]);

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);
   const [columnVisibility, setColumnVisibility] = useState(() => {
      const savedVisibility = localStorage.getItem('journalVoucherColumnVisibility');
      if (savedVisibility) return JSON.parse(savedVisibility);

      if (user?.viewJson) {
         const companySettings = user.viewJson.find((item) => item.companyId === user?.loginhistory?.companyId);
         if (companySettings?.journalVoucher) return companySettings.journalVoucher;
      }

      return {
         docNumber: true,
         txnDate: true,
         daybookname: true,
         notes: true,
         total_amount: true,
      };
   });
   const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const backgroundColor = useColorModeValue('white', 'rgba(12, 20, 41, 1)');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isEditMode, setIsEditMode] = React.useState(false);

   // Fetch data on component mount
   useEffect(() => {
      fetchData();
   }, []);

   const fetchData = async (page = currentPage, size = pageSize) => {
      try {
         await dispatch(
            getJournalVoucher({
               companyId: user?.loginhistory?.companyId,
               sortBy: sorting.length ? sorting[0]?.docNumber : 'docNumber',
            }),
         );
      } catch (error) {
         toast({
            title: 'Error fetching journal vouchers',
            description: error.message || 'Please try again',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const columns = columnsJournalVoucherColumn
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            console.log('data', selectedRowId);
            await dispatch(
               deleteJournalVoucher({
                  companyId: selectedRowId.companyId,
                  daybookId: selectedRowId.daybookId,
                  docNumber: selectedRowId.docNumber,
               }),
            );
            fetchData(); // Refresh data after deletion
         } catch (error) {
            toast({
               title: 'Error deleting journal voucher',
               description: error.message || 'Please try again',
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         } finally {
            setDeleteDialogOpen(false);
         }
      }
   };

   const handleDeleteClick = (data) => {
      console.log('SelectedRowId', data);
      setSelectedRowId(data);
      setDeleteDialogOpen(true);
   };

   const table = useReactTable({
      data: filteredData,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = async () => {
      try {
         await fetchData(); // Refresh data after save
         toast({
            title: `Journal voucher ${isEditMode ? 'updated' : 'created'} successfully`,
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         toast({
            title: `Error ${isEditMode ? 'updating' : 'creating'} journal voucher`,
            description: error.message || 'Please try again',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         onClose();
      }
   };

   const downloadPDF = () => {
      const doc = new jsPDF();
      const visibleColumns = columnsJournalVoucherColumn
         .filter((col) => columnVisibility[col.id])
         .map((col) => col.header);

      const dataToExport = filteredData.map((row) =>
         visibleColumns.map((header) => row[columnsJournalVoucherColumn.find((col) => col.header === header).id]),
      );

      doc.autoTable({
         head: [visibleColumns],
         body: dataToExport,
      });

      doc.save('journal_vouchers.pdf');
   };

   const downloadExcel = () => {
      const workbook = XLSX.utils.book_new();
      const visibleColumns = columnsJournalVoucherColumn
         .filter((col) => columnVisibility[col.id])
         .map((col) => col.header);

      const dataToExport = filteredData.map((row) =>
         visibleColumns.map((header) => row[columnsJournalVoucherColumn.find((col) => col.header === header).id]),
      );

      const worksheetData = [visibleColumns, ...dataToExport];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Journal Vouchers');
      XLSX.writeFile(workbook, 'journal_vouchers.xlsx');
   };

   const handlePageChange = (directionOrPage) => {
      if (typeof directionOrPage === 'number') {
         // Direct page number navigation
         setCurrentPage(directionOrPage);
      } else {
         // Previous/next navigation
         const newPage = directionOrPage === 'next' ? pagination.nextPage : pagination.previousPage;
         if (newPage) setCurrentPage(newPage);
      }
   };

   const handlePageClick = () => {
      setIsEditingPage(true);
      setPageInputValue(''); // Clear input value when starting to edit
   };

   const handlePageInputSubmit = () => {
      const page = parseInt(pageInputValue);
      if (!isNaN(page) && page >= 1 && page <= pagination?.totalPages) {
         handlePageChange(page);
      }
      setIsEditingPage(false);
      setPageInputValue('');
   };

   const handlePageInputBlur = () => {
      handlePageInputSubmit();
   };

   const handlePageKeyDown = (e) => {
      if (e.key === 'Enter') {
         handlePageInputSubmit();
      } else if (e.key === 'Escape') {
         setIsEditingPage(false);
         setPageInputValue('');
      }
   };

   const handlePageSizeChange = (e) => {
      const value = e.target.value;

      // If "ALL" is selected, set limit to null or totalProducts to fetch everything
      const newLimit = value === 'ALL' ? pagination?.totalProducts : Number(value);

      setLimit(newLimit);
      setCurrentPage(1); // Reset to page 1 to avoid offset issues
   };

   const paginatedData = React.useMemo(() => {
      if (pageSize === filteredData.length) return filteredData;
      const start = currentPage * pageSize;
      const end = Math.min(start + pageSize, filteredData.length);
      // return filteredData.slice(start, end);
   }, [filteredData, currentPage, pageSize]);

   const totalPages = Math.ceil(filteredData.length / pageSize);

   // Filter related state and functions
   const [selectedFilter, setSelectedFilter] = useState('');
   const [inputValue, setInputValue] = useState('');
   const [TITLEInputValue, setTITLEInputValue] = useState('');
   const [DateInputValue, setDateInputValue] = useState('');
   const [AmountInputValue, setAmountInputValue] = useState('');
   const [NOTESInputValue, setNOTESInputValue] = useState('');
   const [selectedColumn, setSelectedColumn] = useState(null);
   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   useEffect(() => {
      localStorage.setItem('journalVoucherColumnVisibility', JSON.stringify(columnVisibility));
   }, [columnVisibility]);

   const ColumnVisibilityModal = ({ isOpen, onClose, columnVisibility, setColumnVisibility, user }) => {
      const [localVisibility, setLocalVisibility] = useState(columnVisibility);
      const dispatch = useDispatch();
      const toast = useToast();
      const companyId = Number(localStorage.getItem('companyId'));

      // Get theme mode
      const { colorMode } = useColorMode();
      const isDark = colorMode === 'dark';

      // Handle Escape key
      useEffect(() => {
         const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
               onClose();
            }
         };

         window.addEventListener('keydown', handleKeyDown, true);
         return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
         };
      }, [onClose]);

      // Sync local state with prop changes
      useEffect(() => {
         if (isOpen) {
            setLocalVisibility(columnVisibility);
         }
      }, [isOpen, columnVisibility]);

      const handleSave = async () => {
         try {
            // Update localStorage
            localStorage.setItem('journalVoucherColumnVisibility', JSON.stringify(localVisibility));

            // Update server with journalVoucher settings
            if (user?.viewJson) {
               const updatedViewJson = user.viewJson.map((item) =>
                  item.companyId === companyId ? { ...item, journalVoucher: localVisibility } : item,
               );

               await dispatch(
                  postColumnsHideShow({
                     userId: user?.id,
                     viewJson: updatedViewJson,
                  }),
               );
            }

            // Update parent state
            setColumnVisibility(localVisibility);

            toast({
               title: 'Column settings saved successfully',
               status: 'success',
               duration: 3000,
               isClosable: true,
            });
            onClose();
         } catch (error) {
            toast({
               title: 'Failed to save column settings',
               status: 'error',
               description: error.message,
               duration: 3000,
               isClosable: true,
            });
         }
      };

      // Conditional render check
      if (!isOpen) return null;

      return (
         <div className="fixed inset-0 z-[999] flex items-center justify-center p-4">
            {/* Overlay with blur */}
            <div
               className={`absolute inset-0 transition-colors duration-300 ${isDark ? 'bg-black/70' : 'bg-black/40'}`}
               onClick={onClose}
            />

            {/* Modal Content */}
            <div
               className={`relative w-full max-w-2xl transform transition-all duration-300 ${
                  isDark
                     ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'
                     : 'bg-gradient-to-br from-white via-gray-50 to-white'
               } rounded-2xl shadow-2xl border ${
                  isDark ? 'border-slate-700/50' : 'border-gray-200/50'
               } overflow-hidden flex flex-col max-h-[80vh]`}>
               {/* Header - Fixed */}
               <div
                  className={`relative px-8 py-6 border-b flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <h2 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Show/Hide Columns</h2>
                  <p className={`mt-1 text-sm ${isDark ? 'text-slate-400' : 'text-gray-600'}`}>
                     Customize which columns appear in your journal voucher table
                  </p>
                  <button
                     onClick={onClose}
                     className={`absolute top-6 right-6 p-2 rounded-lg transition-all duration-200 ${
                        isDark
                           ? 'hover:bg-slate-700/50 text-slate-400 hover:text-white'
                           : 'hover:bg-gray-100 text-gray-500 hover:text-gray-900'
                     }`}>
                     <X className="w-5 h-5" />
                  </button>
               </div>

               {/* Body - Scrollable */}
               <div className="flex-1 overflow-y-auto px-8 py-6">
                  <div className="grid grid-cols-2 gap-4">
                     {Object.entries(localVisibility).map(([key, value]) => (
                        <div
                           key={key}
                           className={`group relative p-5 rounded-xl transition-all duration-300 border-2 ${
                              value
                                 ? isDark
                                    ? 'bg-gradient-to-br from-blue-900/20 to-indigo-900/20 border-blue-500/50 shadow-lg shadow-blue-500/10'
                                    : 'bg-gradient-to-br from-blue-50/50 to-indigo-50/50 border-blue-400/50 shadow-lg shadow-blue-200/30'
                                 : isDark
                                 ? 'bg-slate-800/30 border-slate-700/30 hover:border-slate-600/50'
                                 : 'bg-white/50 border-gray-300/30 hover:border-gray-400/50'
                           } cursor-pointer hover:scale-[1.02]`}
                           onClick={() => setLocalVisibility((prev) => ({ ...prev, [key]: !prev[key] }))}>
                           {/* Toggle Switch */}
                           <div className="flex items-center justify-between">
                              <label
                                 className={`font-semibold text-base cursor-pointer transition-colors duration-200 ${
                                    isDark ? 'text-white' : 'text-gray-900'
                                 }`}>
                                 {key.split(/(?=[A-Z])/).join(' ')}
                              </label>

                              <div
                                 className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-300 ${
                                    value
                                       ? isDark
                                          ? 'bg-gradient-to-r from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30'
                                          : 'bg-gradient-to-r from-blue-500 to-indigo-500 shadow-lg shadow-blue-400/30'
                                       : isDark
                                       ? 'bg-slate-700'
                                       : 'bg-gray-300'
                                 }`}>
                                 <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 shadow-md ${
                                       value ? 'translate-x-6' : 'translate-x-1'
                                    }`}
                                 />
                              </div>
                           </div>

                           {/* Status indicator */}
                           <div
                              className={`mt-3 flex items-center gap-2 text-xs font-medium ${
                                 value
                                    ? isDark
                                       ? 'text-blue-400'
                                       : 'text-blue-600'
                                    : isDark
                                    ? 'text-slate-500'
                                    : 'text-gray-500'
                              }`}>
                              <div
                                 className={`h-1.5 w-1.5 rounded-full ${
                                    value
                                       ? isDark
                                          ? 'bg-blue-400 shadow-lg shadow-blue-400/50'
                                          : 'bg-blue-500 shadow-lg shadow-blue-400/50'
                                       : isDark
                                       ? 'bg-slate-600'
                                       : 'bg-gray-400'
                                 }`}
                              />
                              {value ? 'Visible' : 'Hidden'}
                           </div>
                        </div>
                     ))}
                  </div>
               </div>

               {/* Footer - Fixed */}
               <div
                  className={`px-8 py-5 border-t flex justify-end gap-3 flex-shrink-0 ${
                     isDark
                        ? 'border-slate-700/50 bg-gradient-to-r from-slate-800/50 to-slate-900/50'
                        : 'border-gray-200/50 bg-gradient-to-r from-gray-50/50 to-white/50'
                  }`}>
                  <button
                     onClick={onClose}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 ${
                        isDark
                           ? 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
                           : 'text-gray-700 hover:bg-gray-200 hover:text-gray-900'
                     }`}>
                     Cancel
                  </button>
                  <button
                     onClick={handleSave}
                     className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-lg ${
                        isDark
                           ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white shadow-blue-500/30'
                           : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-blue-400/30'
                     }`}>
                     Save
                  </button>
               </div>
            </div>
         </div>
      );
   };

   return (
      <Box className="mt-14" bg={backgroundColor}>
         <Flex px={{ base: '1px', md: '20px' }} mb="8px" justifyContent="space-between" align="center" overflowX="auto">
            <Flex align="center" gap={10}>
               <Text color={textColor} fontSize={{ base: '15px', lg: '22px' }} fontWeight="700" lineHeight="100%">
                  Journal - Voucher
               </Text>
            </Flex>
            <Flex align="center" gap={2} flexShrink={0} p={3}>
               {!isMobileOrTablet && (Admin || JournalVoucherRight?.add) && !user.isExpired && (
                  <button
                     onClick={() => {
                        setCurrentRow({});
                        setIsEditMode(false);
                        onOpen();
                     }}
                     className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                        isDark
                           ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                           : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                     }`}>
                     {/* Gradient overlay on hover */}
                     <span
                        className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                           isDark ? 'via-cyan-100/20' : 'via-white/30'
                        }`}></span>

                     {/* Icon container with background */}
                     <span
                        className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                           isDark ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30' : 'bg-white/20 group-hover:bg-white/30'
                        }`}>
                        <svg
                           className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                        </svg>
                     </span>

                     <span className="relative text-base font-semibold">Add New</span>
                  </button>
               )}
               <IconButton
                  colorScheme="gray"
                  icon={<BsEye />}
                  size="md"
                  mr={1}
                  onClick={() => setIsColumnModalOpen(true)}
               />
               <MotionFlex
                  ref={wrapperRef}
                  align="center"
                  bg={bg}
                  borderRadius="full"
                  // me="20px"
                  cursor="pointer"
                  px={expanded ? 3 : 0}
                  w={expanded ? '200px' : '40px'}
                  h="40px"
                  transition="all 0.3s ease"
                  onClick={() => setExpanded(true)}>
                  <MotionSearchIcon
                     color={icon}
                     animate={{ rotate: expanded ? 0 : 90 }}
                     transition={{ duration: 0.3 }}
                     style={{ marginRight: expanded ? '8px' : '10px', marginLeft: expanded ? '0' : '10px' }}
                  />
                  {expanded && (
                     <Input
                        variant="unstyled"
                        placeholder="Search..."
                        value={searchQuery}
                        color={icon}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        autoFocus
                     />
                  )}
               </MotionFlex>
               {isMobileOrTablet && (Admin || JournalVoucherRight?.add) && !user.isExpired && (
                  <Box position="fixed" bottom="4" right="4" zIndex={999}>
                     <button
                        onClick={() => {
                           setCurrentRow({});
                           setIsEditMode(false);
                           onOpen();
                        }}
                        className={`group relative flex items-center justify-center gap-3 py-2 px-7 rounded-xl font-medium shadow-lg transition-all duration-300 ease-out transform hover:-translate-y-1 focus:outline-none focus:ring-4 active:scale-95 overflow-hidden border ${
                           isDark
                              ? 'bg-gradient-to-br from-cyan-400 to-blue-500 hover:from-cyan-300 hover:to-blue-400 text-white shadow-cyan-500/30 hover:shadow-2xl hover:shadow-cyan-400/40 focus:ring-cyan-200/50 border-cyan-300/30'
                              : 'bg-gradient-to-br from-emerald-400 to-teal-500 hover:from-emerald-300 hover:to-teal-400 text-white shadow-emerald-500/30 hover:shadow-2xl hover:shadow-emerald-400/40 focus:ring-emerald-200/70 border-emerald-300/50'
                        }`}>
                        {/* Gradient overlay on hover */}
                        <span
                           className={`absolute inset-0 bg-gradient-to-r from-white/0 via-white/30 to-white/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out ${
                              isDark ? 'via-cyan-100/20' : 'via-white/30'
                           }`}></span>

                        {/* Icon container with background */}
                        <span
                           className={`relative flex items-center justify-center w-6 h-6 rounded-lg backdrop-blur-sm transition-all duration-300 ${
                              isDark
                                 ? 'bg-cyan-100/20 group-hover:bg-cyan-100/30'
                                 : 'bg-white/20 group-hover:bg-white/30'
                           }`}>
                           <svg
                              className="w-4 h-4 transition-transform duration-300 group-hover:rotate-90"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
                           </svg>
                        </span>

                        <span className="relative text-base font-semibold">Add New</span>
                     </button>
                  </Box>
               )}
            </Flex>
         </Flex>

         <DynamicTable
            right={JournalVoucherRight}
            table={table}
            data={JournalVoucher}
            handleImageClick={() => {}}
            toggleDropdown={() => {}}
            filter={filter}
            emptyMessage="No Journal voucher data found"
            onEditClick={(row) => {
               setCurrentRow(row);
               setIsEditMode(true);
               onOpen();
            }}
            canDelete={true}
            columnVisibility={columnVisibility}
            onDeleteClick={(id) => {
               handleDeleteClick(id);
            }}
            columnsData={columnsJournalVoucherColumn}
            sorting={sorting}
            limit={limit}
            setCurrentRow={setCurrentRow}
            onOpen={onOpen}
            setIsEditMode={setIsEditMode}
            setDeleteDialogOpen={setDeleteDialogOpen}
            setSelectedRowId={setSelectedRowId}
            type="jv"
            // debouncedSearchQuery={debouncedSearchQuery}
         />

         <JournalVoucherForm
            isOpen={isOpen}
            onClose={onClose}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Journal Voucher"
         />

         <ColumnVisibilityModal
            isOpen={isColumnModalOpen}
            onClose={() => setIsColumnModalOpen(false)}
            columnVisibility={columnVisibility}
            setColumnVisibility={setColumnVisibility}
            user={user}
         />
      </Box>
   );
}
